const globalContent = {
  announcementTitle: {
    en: "Announcements",
    es: "Anuncios",
    fr: "Annonces",
    hi: "घोषणाएं",
    ar: "الإعلانات",
  },
  payRollTitle: {
    en: "Payroll Cut Off",
    es: "Corte de nómina",
    fr: "Coupure de la paie",
    hi: "वेतन कटौती",
    ar: "قطع الرواتب",
  },
  payRoll: {
    en: "Payroll is now closed for May.",
    es: "La nómina ya está cerrada para mayo.",
    fr: "La paie est maintenant fermée pour le mois de mai",
    hi: "पेरोल अब मई के लिए बंद है।",
    ar: "كشوف المرتبات مغلقة الآن لشهر مايو.",
  },
  nextPayRoll: {
    en: "Next payroll cut off is on the 11th of June COB.",
    es: "El próximo corte de nómina es el COB del 11 de junio.",
    fr: "La prochaine date limite de paie est le 11 juin COB.",
    hi: "अगली पेरोल कट ऑफ 11 जून COB को है।",
    ar: "سيتم قطع الرواتب التالي في 11 يونيو COB.",
  },
  user: {
    en: "User Guidelines and Manuals",
    es: "Directrices y manuales de usuario",
    fr: "Instructions et manuels d'utilisation",
    hi: "उपयोगकर्ता दिशानिर्देश और नियमावली",
    ar: "إرشادات وأدلة المستخدم",
  },
  assistance: {
    en: "For assistance in navigating through Altron OneTouch, please click here to view the user manuals and video...",
    es: "Para obtener ayuda para navegar a través de Altron OneTouch, haga clic aquí para ver los manuales de usuario y el video...",
    fr: "Pour obtenir de l'aide pour naviguer dans Altron OneTouch, veuillez cliquer ici pour afficher les manuels d'utilisation et la vidéo…",
    hi: "Altron OneTouch के माध्यम से नेविगेट करने में सहायता के लिए, उपयोगकर्ता मैनुअल और वीडियो देखने के लिए कृपया यहां क्लिक करें...",
    ar: "للمساعدة في التنقل عبر Altron OneTouch ، يرجى النقر هنا لعرض أدلة المستخدم والفيديو ...",
  },
  assist: {
    en: "Altron Assist - Employee Assistance Bot",
    es: "Altron Assist - Bot de asistencia al empleado",
    fr: "Altron Assist - Bot d'assistance aux employés",
    hi: "एलट्रॉन असिस्ट - कर्मचारी सहायता बॉट",
    ar: "Altron Assist - روبوت لمساعدة الموظفين",
  },
  virtual: {
    en: "Click here to access you virtual agent for assistance",
    es: "Haga clic aquí para acceder a su agente virtual para obtener asistencia.",
    fr: "Cliquez ici pour accéder à votre agent virtuel d'assistance",
    hi: "सहायता के लिए अपने वर्चुअल एजेंट तक पहुँचने के लिए यहाँ क्लिक करें",
    ar: "انقر هنا للوصول إلى وكيلك الظاهري للحصول على المساعدة",
  },
  items: {
    en: "items",
    es: "cosas",
    fr: "article",
    hi: "सामान",
    ar: "أغراض",
  },
  application: {
    en: "Applications",
    es: "Applicaciones",
    fr: "Applications",
    hi: "अनुप्रयोग",
    ar: "التطبيقات",
  },
  pay: {
    en: "Pay",
    es: "Pagar",
    fr: "Payer",
    hi: "भुगतान करना",
    ar: "يدفع",
  },
  career: {
    en: "Career",
    es: "Carrera",
    fr: "Carrière",
    hi: "आजीविका",
    ar: "حياة مهنية",
  },
  onboarding: {
    en: "Onboarding",
    es: "Inducción",
    fr: "Intégration",
    hi: "ज्ञानप्राप्ति",
    ar: "على متن الطائرة",
  },
  absence: {
    en: "Absence",
    es: "Ausencia",
    fr: "Absence",
    hi: "अनुपस्थिति",
    ar: "غياب",
  },
  benefits: {
    en: "Benefits",
    es: "Beneficios",
    fr: "Avantages",
    hi: "फ़ायदे",
    ar: "فوائد",
  },
  tal: {
    en: "Talent and Performance",
    es: "Talento y Desempeño",
    fr: "Talents et performances",
    hi: "प्रतिभा और प्रदर्शन",
    ar: "الموهبة والأداء",
  },
  ex: {
    en: "Expenses",
    es: "Gastos",
    fr: "Paramètres",
    hi: "खर्च",
    ar: "نفقات",
  },
  personal: {
    en: "Personal Information",
    es: "Informacion Personal",
    fr: "Informations Personnelles",
    hi: "व्यक्तिगत जानकारी",
    ar: "معلومات شخصية",
  },
  opp: {
    en: "Opportunity Graph",
    es: "Gráfico de oportunidad",
    fr: "Graphique des opportunités",
    hi: "अवसर ग्राफ",
    ar: "الرسم البياني للفرصة",
  },
  children: {
    en: "children",
    es: "niños",
    fr: "enfants",
    hi: "बच्चे",
    ar: "أطفال",
  },
  className: {
    en: "Add a ClassName",
    es: "Agregar un nombre de clase",
    fr: "Ajouter un nom de classe",
    hi: "क्लासनाम जोड़ें",
    ar: "أضف اسم الفصل",
  },
  save: {
    en: "Save Changes",
    es: "Guardar cambios",
    fr: "Sauvegarder les modifications",
    hi: "परिवर्तनों को सुरक्षित करें",
    ar: "حفظ التغييرات",
  },
  wel: {
    en: "Welcome, ",
    es: "Bienvenido, ",
    fr: "Bienvenu, ",
    hi: "स्वागत, ",
    ar: "مرحباً، ",
  },
  inbox: {
    en: "Inbox",
    es: "Bandeja de entrada",
    fr: "Boîte de réception",
    hi: "इनबॉक्स",
    ar: "صندوق الوارد",
  },
  item: {
    en: "1 item",
    es: "1 cosa",
    fr: "1 article",
    hi: "1 समान",
    ar: "عنصر واحد",
  },
  cont: {
    en: "Set Content",
    es: "Establecer contenido",
    fr: "Définir le contenu",
    hi: "सामग्री सेट करें",
    ar: "تعيين المحتوى",
  },
  goal: {
    en: "Goal Setting Template: Offentse Sepeng",
    es: "Plantilla de establecimiento de objetivos: ofensiva Sepeng",
    fr: "Modèle d'établissement d'objectifs : Offense Sepeng",
    hi: "लक्ष्य निर्धारण टेम्प्लेट: ऑफेंस सेपेंग",
    ar: "نموذج تحديد الهدف: Offentse Sepeng",
  },
  date: {
    en: "3 month(s) ag - Effective 2021/04/30",
    es: "3 mes(es) ag - Efectivo 2021/04/30",
    fr: "3 mois ag - En vigueur 2021/04/30",
    hi: "3 महीने (ओं) एजी - 2021/04/30 से प्रभावी",
    ar: "3 أشهر (أشهر) - اعتبارًا من 2021/04/30",
  },
  go: {
    en: "Go To Inbox",
    es: "Ir a la bandeja de entrada",
    fr: "Aller à la boîte de réception",
    hi: "इनबॉक्स में जाएं",
    ar: "انتقل إلى Inbox",
  },
  theme: {
    en: "Theme and Title",
    es: "Tema y Título",
    fr: "Thème et titre",
    hi: "थीम और शीर्षक",
    ar: "الموضوع والعنوان",
  },
  company: {
    en: "Company Name",
    es: "Compaña Nombre",
    fr: "Nom de l'entreprise",
    hi: "कंपनी का नाम",
    ar: "اسم الشركة",
  },
  settings: {
    en: "Settings",
    es: "Ajustes",
    fr: "Paramètres",
    hi: "समायोजन",
    ar: "إعدادات",
  },
};

export default globalContent;
